import React from 'react';
import { DateTime } from 'luxon';
import { paginateArray, sortByPropAlphabetically } from '../../../helpers/utils';
import UPCode from '../../../components/UPcode';
import SideBar from '../../Common/SideBar';
import SpotlightHeader from '../../Common/Header';
import './Trainings.scss';
const Row = ({
  employee,
  accent_color
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: "list-row list-item",
    style: {
      '--accent-color': accent_color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "name"
  }, employee.name), /*#__PURE__*/React.createElement("div", {
    className: `completed-field ${employee.completed ? 'completed-field--yes' : 'completed-field--no'}`
  }, employee.completed ? 'Yes' : 'No'));
};
const Trainings = props => {
  var _data$hits, _employeesPaginated;
  const {
    data,
    metadata,
    text,
    bohStyle,
    deviceId,
    organizationId,
    tracking,
    properties
  } = props;
  const {
    accent_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const employees = (data === null || data === void 0 ? void 0 : data.employees) || [];
  const sortedEmployees = sortByPropAlphabetically(employees, 'name');
  const employeesPaginated = paginateArray(sortedEmployees, 10);
  const hits = (_data$hits = data === null || data === void 0 ? void 0 : data.hits) !== null && _data$hits !== void 0 ? _data$hits : 0;
  const timezone = data === null || data === void 0 ? void 0 : data.timezone;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const employeesPage = (_employeesPaginated = employeesPaginated[hits % employeesPaginated.length]) !== null && _employeesPaginated !== void 0 ? _employeesPaginated : [];
  const rowData = employeesPage.length ? employeesPage.slice(0, 10) : [];
  const rows = rowData.map((e, index) => /*#__PURE__*/React.createElement(Row, {
    key: `${e.employee}-${index}`,
    employee: e,
    accent_color: accent_color,
    text: text
  }));
  const lastUpdated = DateTime.fromISO(data === null || data === void 0 ? void 0 : data.last_updated, {
    zone: timezone
  }).setLocale('en-US');
  const bodyLastUpdated = data !== null && data !== void 0 && data.last_updated ? ` as of ${lastUpdated.toFormat('MM/dd')} at ${lastUpdated.toFormat('t')}` : '';
  const body = data !== null && data !== void 0 && data.title ? `${data.title} completion` : '';
  const description = `${body} ${bodyLastUpdated}`;
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "training-status-container",
    style: containerStyle
  }, Header, /*#__PURE__*/React.createElement("div", {
    className: "training-status-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-row list-header",
    style: listHeaderRowStyle
  }, /*#__PURE__*/React.createElement("p", {
    className: "employee_header"
  }, "Employee"), /*#__PURE__*/React.createElement("p", null, "Completed")), rows), tracking ? /*#__PURE__*/React.createElement(UPCode, {
    properties: properties,
    tracking: {
      ...tracking,
      logo: metadata.logo
    },
    playing: true,
    clickable: false,
    rightPanelBackgroundColor: accent_color,
    UPcodeBackground: "#FFFFFF",
    size: 376,
    deviceId: deviceId,
    organizationId: organizationId
  }) : /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default Trainings;